var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPreVideoFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "46 / Fill / Video"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8955 3.13086H20.9828L25.0754 7.97625L26.7061 9.90679H32.6187L28.5261 5.06139L26.8955 3.13086ZM38.5317 9.90679H44.87V9.13086C44.87 5.81715 42.1837 3.13086 38.87 3.13086H32.8085L37.0781 8.1858L38.5317 9.90679ZM20.793 9.90679L15.279 3.37846C12.7991 4.11514 10.9903 6.41177 10.9903 9.13085V9.90679H20.793ZM10.9903 14.4241H44.87V28.7519C44.87 32.0656 42.1837 34.7519 38.87 34.7519H16.9903C13.6766 34.7519 10.9903 32.0656 10.9903 28.7519V14.4241ZM31.6728 26.0928L26.5102 29.855C25.2339 30.785 23.4126 29.9002 23.4126 28.3501V20.8258C23.4126 19.2758 25.2339 18.3909 26.5102 19.321L31.6728 23.0831C32.7053 23.8355 32.7053 25.3404 31.6728 26.0928ZM3.43368 29.3575L8.16722 14.0114V27.9759C8.16722 33.2775 12.4649 37.5752 17.7665 37.5752H36.3537L35.8082 39.3435C34.7052 42.9195 30.9121 44.9242 27.3361 43.8212L7.9114 37.8296C4.33541 36.7266 2.33066 32.9335 3.43368 29.3575Z",
    fill: "var(--secondary-6)"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreVideoFilled);
export default __webpack_public_path__ + "static/media/preVideoFilled.b37a3c02d6634695bd1e6f614ab29705.svg";
export { ForwardRef as ReactComponent };